import React, { Component } from 'react'
import { KeyboardArrowDown, Sort } from '@mui/icons-material'
import { MenuItem, Select } from '@mui/material'

class SearchPageFiltersDropdown extends Component {
  render() {
    const { fieldName, icon, label, value, onChange, menuItems } = this.props
    const dropDownIcon = icon === 'Sort' ? Sort : KeyboardArrowDown

    return (
      <div className={`Search-page__filters-${fieldName}-wrapper`}>
        <span className="Search-page__filters-label">{label}</span>
        <Select
          className={`Search-page__filters-${fieldName}`}
          value={value}
          onChange={onChange}
          displayEmpty
          IconComponent={dropDownIcon}
        >
          {menuItems.map((menuItem, index) => {
            let lastClass = index + 1 === menuItems.length ? 'last' : ''
            return (
              <MenuItem
                key={index}
                className={`Search-page__filters-menu-item ${lastClass}`}
                value={menuItem.value}
              >
                {menuItem.primaryText}
              </MenuItem>
            )
          })}
        </Select>
      </div>
    )
  }
}

export default SearchPageFiltersDropdown
